export default __webpack_public_path__ + "static/media/Mulish-Black.225cdbf5.ttf";